<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.lists')}`">
              <div class="v-table">
                <TableServer type="lists" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.list-items')}`">
              <div class="v-table">
                <TableServer type="listItems" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-list')}`">
              <ListForm v-if="fetcherAdminSchemas.forms['List']" />
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-list-item')}`">
              <ListItemForm v-if="fetcherAdminSchemas.forms['ListItem']" />
            </b-tab>
            <b-tab
              v-if="listId !== null && fetcherAdminList.id > 0"
              :title="`${this.$i18n.t('JSON.list')}#${listId}`"
            >
              <ListForm
                v-if="fetcherAdminSchemas.forms['List']"
                :list="fetcherAdminList"
                mode="edit"
              />
            </b-tab>
            <b-tab
              v-if="listItemId !== null && fetcherAdminListItem.id > 0"
              :title="`${this.$i18n.t('JSON.list-item')}#${listItemId}`"
            >
              <ListItemForm
                v-if="fetcherAdminSchemas.forms['ListItem']"
                :list-item="fetcherAdminListItem"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    MadModal: () => import('@/components/MadModal'),
    ListForm: () => import('@/components/admin/fetcher/modals/forms/ListForm'),
    ListItemForm: () => import('@/components/admin/fetcher/modals/forms/ListItemForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    listId: {
      type: Number,
      default: () => 0,
    },
    listItemId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminList: (state) => state.fetcherAdminList.fetcherAdminList,
      fetcherAdminListItem: (state) => state.fetcherAdminListItem.fetcherAdminListItem,
    }),

    modalId() {
      return 'list';
    },
  },

  watch: {
    listId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminList();
      }
    },

    listItemId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminListItem();
      }
    },
  },

  methods: {
    ...mapActions([
      'getFetcherAdminList', //
      'getFetcherAdminListItem',
    ]),

    async loadFetcherAdminList() {
      try {
        await this.getFetcherAdminList({
          params: {
            lid: this.listId,
          },
        });

        // console.log('list', this.list);

        // success
        // console.log('success loading list!');
      } catch (error) {
        // error
        // console.log('error loading list!');
      }
    },

    async loadFetcherAdminListItem() {
      try {
        await this.getFetcherAdminListItem({
          params: {
            liid: this.listItemId,
          },
        });

        // console.log('listItem', this.listItem);

        // success
        // console.log('success loading listItem!');
      } catch (error) {
        // error
        // console.log('error loading listItem!');
      }
    },

    onOpened() {
      if (this.listId !== null) {
        this.loadFetcherAdminList();
      }

      if (this.listItemId !== null) {
        this.loadFetcherAdminListItem();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
